import { defineStore } from 'pinia';

export const useCustomerCancelStore = defineStore('customer-cancel', {
  state: () => ({
    showedPopup: false
  }),
  actions: {
    showPopup () {
      this.showedPopup = true;
    },
    hidePopup () {
      this.showedPopup = false;
    }
  },
});
